import apiEndPoints from "utils/apiEndPoints";
import { apiCall } from "utils/httpClient";

const header = {
  "Content-Type": "application/x-www-form-urlencoded",
  //   "access-control-allow-origin": "*",
};
// visitor_module
const visitorList = async (params) => {
  const data = await apiCall("post", params.search_type === 2 ? apiEndPoints.VISITORLIST : apiEndPoints.GETVISITORLIST, params);
  return data;
};
const visitorDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.VISITORDETAIL, params);
  return data;
};
const editVisitor = async (params) => {
  const data = await apiCall("post", apiEndPoints.EDITVISITOR, params);
  return data;
};
const addVisitor = async (params) => {
  const data = await apiCall("post", apiEndPoints.ADDVISITOR, params);
  return data;
};
const addBulkImageUpload = async (params) => {
  const data = await apiCall("post", apiEndPoints.BULKIMAGEUPLOAD, params, header);
  return data;
};
const addBulkCsvUpload = async (params) => {
  const data = await apiCall("post", apiEndPoints.BULKCSVUPLOAD, params, header);
  return data;
};
const downloadCSVFile = async (params) => {
  const data = await apiCall("post", apiEndPoints.DOWNLOADCSVFILE, params);
  return data;
};
const visitorMobileCheck = async (params) => {
  const data = await apiCall("post", apiEndPoints.VISITORMOBILECHECK, params);
  return data;
};
// New_Upload_module
const bulkVisitList = async (params) => {
  const data = await apiCall("post", apiEndPoints.BULKVISITLIST, params);
  return data;
};
const bulkVisitDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.BULKVISITDETAIL, params);
  return data;
};
// Verify_lead_module
const bulkVerifyVisitList = async (params) => {
  const data = await apiCall("post", apiEndPoints.BULKVERIFYVISITLIST, params);
  return data;
};
const visitStatusUpdate = async (params) => {
  const data = await apiCall("post", apiEndPoints.VISITORSTATUSUPDATE, params);
  return data;
};
const verifyVisitDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.VERIFYVISITORDETAIL, params);
  return data;
};
const editUnverfiyCsvVisit = async (params) => {
  const data = await apiCall("post", apiEndPoints.EDITUNVERIFYCSVVISIT, params);
  return data;
};
// public_lead_when_property_not_selected
const addVisitProperty = async (params) => {
  const data = await apiCall("post", apiEndPoints.ADDVISITPROPERTY, params);
  return data;
};
const getVisitorList = async (params) => {
  const data = await apiCall("post", params.search_type === 2 ? apiEndPoints.GETVISITORLIST : apiEndPoints.GETVISITORLIST, params);
  return data;
};
const checkReferenceNmbrExist = async (params) => {
  const data = await apiCall("post",  apiEndPoints.CHECK_REFERENCE_EXIST, params);
  return data;
};



const visitorService = {
  visitorList,
  visitorDetail,
  editVisitor,
  addVisitor,
  visitorMobileCheck,
  bulkVisitList,
  bulkVisitDetail,
  bulkVerifyVisitList,
  visitStatusUpdate,
  verifyVisitDetail,
  editUnverfiyCsvVisit,
  addVisitProperty,
  addBulkImageUpload,
  addBulkCsvUpload,
  downloadCSVFile,
  getVisitorList,
  checkReferenceNmbrExist
};

export default visitorService;
